import moment from "moment";
export function chunkPeriod (from, to, segmentDays = 5, shift = true) {
    let loopCount = 1;
    let shiftDay = +shift;

    const dates = [];

    let bufferDate = new Date(from);
    let shiftDate = new Date(from);
    bufferDate.setDate(bufferDate.getDate() + segmentDays);
    if (bufferDate < new Date(to)) {
        let tempDate = new Date(from);
        while (tempDate < new Date(to)) {
            bufferDate = new Date(tempDate);
            shiftDate = new Date(bufferDate);
            shiftDate.setDate(shiftDate.getDate() + shiftDay);
            tempDate.setDate(tempDate.getDate() + segmentDays);

            dates.push({
                'dateFrom': (loopCount > 1) ? moment(shiftDate.toISOString(), 'YYYY-MM-DD').format('YYYY-MM-DD')
                    : moment(bufferDate.toISOString(), 'YYYY-MM-DD').format('YYYY-MM-DD'),
                'dateTo': (tempDate < new Date(to)) ? moment(tempDate.toISOString(), 'YYYY-MM-DD').format('YYYY-MM-DD') : to
            });

            loopCount++;
        }
    }
    return dates
}